import { ISelectOption } from '@apps-common/types/form'

export enum ServiceRequestStatusMonitoringChange {
  Success = 'success',
  Failed = 'failed',
  PendingReview = 'pendingreview',
  Denied = 'denied',
  Cancelled = 'cancelled'
}

export const MONITORING_CHANGES_STATUS_VALUES: ISelectOption[] = [
  { label: 'Success', value: ServiceRequestStatusMonitoringChange.Success },
  { label: 'Failed', value: ServiceRequestStatusMonitoringChange.Failed },
  { label: 'Pending Review', value: ServiceRequestStatusMonitoringChange.PendingReview },
  { label: 'Denied', value: ServiceRequestStatusMonitoringChange.Denied },
  { label: 'Cancelled', value: ServiceRequestStatusMonitoringChange.Cancelled },
  { label: 'Archived', value: 'archived' }
]
